import { Box, Container, Grid } from "@mui/material";
import { useKeycloak } from "@react-keycloak/web";
import { useAtomValue } from "jotai";
import Head from "next/head";
import { baseAtom } from "../../stores/jotai/base";
import { useGetCanvasData } from "../../tanstackQuery/queries/canvas";
import ActivityFeedSegmentCard from "./ActivityFeedSegmentCard";
import CalendarSegmentCard from "./CalendarSegmentCard";
import HomeOverview from "./HomeOverview";
import InsightSegmentCard from "./InsightSegmentCard";
import InterviewsSegmentCard from "./InterviewsSegmentCard";
import TemplateSegmentCard from "./TemplateSegmentCard";

const Home = (props) => {
  const { keycloak } = useKeycloak();
  const base = useAtomValue(baseAtom);

  const { data: canvasDataAll, isLoading: isCanvasDataLoading } =
    useGetCanvasData(
      { accessToken: keycloak.token },
      { groupID: props?.team?.groupID },
      { enabled: !!base?.team?.groupID }
    );

  return (
    <>
      <Head>
        <title>Home - Innovation Within</title>
      </Head>
      <Box sx={{ height: "100%", overflowY: "auto" }}>
        <Container sx={{ padding: "24px 0 48px" }}>
          <Grid container={true} spacing={7}>
            <Grid item={true} container={true} sm={12} spacing={2}>
              <Grid item={true} sm={12}>
                <HomeOverview />
              </Grid>
              <Grid item={true} sm={12} md={6}>
                <ActivityFeedSegmentCard
                  isCanvasLoading={isCanvasDataLoading}
                  canvas={canvasDataAll}
                />
              </Grid>
              <Grid item={true} sm={12} md={6}>
                <TemplateSegmentCard
                  isCanvasLoading={isCanvasDataLoading}
                  canvas={canvasDataAll}
                />
              </Grid>
              <Grid item={true} sm={12} md={6}>
                <CalendarSegmentCard />
              </Grid>
              <Grid item={true} sm={12} md={6}>
                <InterviewsSegmentCard />
              </Grid>
              <Grid item={true} sm={12}>
                <InsightSegmentCard />
              </Grid>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </>
  );
};

export default Home;
